import React from 'react';

export function OfflinePage({ message }) {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
            <div className="text-center max-w-2xl">
                {/* Logo */}
                <img 
                    src="/logo.png" 
                    alt="Musikschule Ybbsfeld" 
                    className="h-40 w-auto mx-auto mb-8"
                    onError={(e) => {
                        // Fallback to SVG
                        if (!e.target.dataset.fallback) {
                            e.target.dataset.fallback = '1';
                            e.target.src = '/logo.svg';
                        } else {
                            e.target.style.display = 'none';
                        }
                    }}
                />
                
                {/* Message */}
                <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
                    <p className="text-xl text-gray-700 leading-relaxed whitespace-pre-line">
                        {message || 'Die Seite wird gerade gewartet. Bitte versuche es später erneut.'}
                    </p>
                </div>
            </div>
        </div>
    );
}
